import Banner from "../components/Banner";
import RegisterCallout from "../components/RegisterCallout";
import Speakers from "../components/Speakers";
import SpeakerData27 from "../data/SpeakerData27";
import { Link } from "react-router-dom";

function ChecklistItem({ children }) {
  return (
    <li className="d-flex mb-3">
      <i
        className="fa fa-check-circle me-4 mt-1 color-yellow"
        style={{ flexShrink: 0 }}
      ></i>
      <span>{children}</span>
    </li>
  );
}

export default function PageWorkshop() {
  return (
    <>
      <Banner
        leftImage="img/bg-banner-round-gradient.webp"
        rightImage="img/bg-banner-post-workshop.webp"
      >
        <div className="col-12 mb-3">
          <div className="display-1 color-white">Post-conference Workshop</div>
        </div>
        <div className="col-12 col-md-9 col-lg-8 col-xl-7 mb-2">
          <p className="color-white mb-5">
            Stay a little longer and get the most value for your time at
            FinComp. This hands-on session is available as a $395 add-on when
            you register, and it includes lunch, giving you extra time to turn
            compensation strategy into an actionable plan.
          </p>
        </div>
        <div className="col-12">
          <a
            href="https://www.omnihotels.com/hotels/san-diego-la-costa"
            target="_blank"
            rel="noreferrer"
            className="btn-white-o me-4"
          >
            Hotel Website
            <i className="fa fa-arrow-right" aria-hidden="true"></i>
          </a>
          <a
            href="https://bookings.omnihotels.com/event/san-diego-la-costa/fincomp-27-"
            target="_blank"
            rel="noreferrer"
            className="btn-white-o ms-4"
          >
            Book Your Stay
            <i className="fa fa-arrow-right" aria-hidden="true"></i>
          </a>
        </div>
      </Banner>

      <section>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-9">
              <h1 className="color-purple mb-3">
                Educating Stakeholders at Every Level: How to Successfully Roll
                Out Your Salary Administration Program
              </h1>
              <p className="mb-0">
                Get the playbook for turning ideas into action. This
                Post-Conference Workshop is designed for HR leaders ready to
                make compensation strategy something their entire organization
                understands. You&apos;ll leave with practical tools built from
                real-world experience guiding organizations through this exact
                process, led by Christie Summervill of BalancedComp.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-purple py-5">
        <div className="container">
          <div className="row mb-4">
            <div className="col-12 text-center">
              <h1 className="color-white mb-0">Your Presenters</h1>
            </div>
          </div>
          <Speakers
            speakers={SpeakerData27}
            filter={["Christie Summervill"]}
            colWidth="4"
            className="justify-content-center"
          />
        </div>
      </section>

      <section>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-8">
              <h1 className="color-purple mb-3">What You&apos;ll Master</h1>
              <p>
                In this practical, discussion-rich workshop, you&apos;ll cover:
              </p>
              <ul className="list-unstyled mb-5">
                <ChecklistItem>
                  How to develop your organization&apos;s salary administration
                  guidelines, how they work, why they matter, and how to explain
                  them to your team. We&apos;ll provide a draft as a starting
                  point.
                </ChecklistItem>
                <ChecklistItem>
                  Comp 101 fundamentals that managers and board members need to
                  understand, plus how to build and deliver this training
                  yourself
                </ChecklistItem>
                <ChecklistItem>
                  How to train managers to answer the compensation questions
                  employees ask most, without getting stuck or being
                  inconsistent
                </ChecklistItem>
              </ul>

              <h1 className="color-purple mb-3">
                What You&apos;ll Walk Away With
              </h1>
              <ul className="list-unstyled mb-4">
                <ChecklistItem>
                  A ready-to-use Comp 101 presentation you can deliver to
                  managers or the board
                </ChecklistItem>
                <ChecklistItem>
                  A second presentation toolkit for training managers to respond
                  to common employee compensation questions
                </ChecklistItem>
                <ChecklistItem>
                  Step-by-step methods for rolling out your salary
                  administration program and gaining buy-in from your board and
                  executive leadership
                </ChecklistItem>
                <ChecklistItem>
                  More confidence coaching managers to talk about pay openly,
                  accurately, and professionally
                </ChecklistItem>
              </ul>
              <p className="mb-5">
                This isn&apos;t a high-level overview. We&apos;ll move from
                philosophy to practical application, with real scenarios and
                tools you can put to work as soon as you&apos;re back in the
                office.
              </p>

              <h1 className="mb-0 color-purple">
                <Link to="/Registration">
                  <mark className="purple-red-highlight color-white fw-bold px-2">
                    Reserve your spot
                  </mark>{" "}
                </Link>
                for $395, lunch included, when you add it to your FinComp
                registration.
              </h1>
            </div>
          </div>
        </div>
      </section>

      <RegisterCallout />
    </>
  );
}
